import { render, staticRenderFns } from "./shipping-zones.vue?vue&type=template&id=37f4a42b&"
import script from "./shipping-zones.vue?vue&type=script&lang=js&"
export * from "./shipping-zones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports